export const env = {
    // api : "http://localhost:3000"
    api : "https://recipe-backend-gd60.onrender.com"
}